import React from "react";
import { atom, useRecoilState } from "recoil";

export const drawCircleState = atom({
  key: "drawCircleState",
  default: true,
});

const CircleToggle = () => {
  const [drawCircle, toggleDrawCircle] = useRecoilState(drawCircleState);
  return (
    <button
      style={{
        position: "absolute",
        bottom: "100px",
        right: "100px",
      }}
      onClick={() => toggleDrawCircle(!drawCircle)}
    >
      <span style={{ fontSize: 60, color: drawCircle ? "blue" : "grey" }}>
        ⊚
      </span>
    </button>
  );
};

export default CircleToggle;
